// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '23a0aa9',
    builtAt: '2026-08-21T14:57:12.690Z',
} as const;
